export function getClientWidth(): number {
  return document.documentElement.clientWidth || document.body.clientWidth;
}

export function addClientWidthToStyles(styleName: string): void {
  const width = getClientWidth();
  document.documentElement.style.setProperty(styleName, `${width}px`);
}

export function getWidthOfClass(className: string): number {
  const element = document.getElementsByClassName(className)[0];
  const positionInfo = element?.getBoundingClientRect();

  return positionInfo?.width;
}

export default function useElementSize() {
  return { addClientWidthToStyles, getClientWidth, getWidthOfClass };
}
